import Vue from 'vue';
import App from './App.vue';
import router from './routes';
// import store from './plugins/store';
import { routerBeforeEach } from './config/interceptors/routes'; // 路由 拦截器配置
import './plugins/iview'; // ui库
import i18n from './plugins/i18n'; // 多语言
import './plugins/service';
import './plugins/project';
import './plugins/amap';
import './assets/css/myview.sass';

Vue.config.productionTip = false;

// 注册一个全局路由守卫
router.beforeEach(routerBeforeEach);

new Vue({
  router,
  // store,
  i18n,
  render: h => h(App),
}).$mount('#app');
